import { render, staticRenderFns } from "./QRManagement.vue?vue&type=template&id=02a52a10&scoped=true"
import script from "./QRManagement.vue?vue&type=script&lang=js"
export * from "./QRManagement.vue?vue&type=script&lang=js"
import style0 from "./QRManagement.vue?vue&type=style&index=0&id=02a52a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a52a10",
  null
  
)

export default component.exports